const rules = {
	user: {
		static: [],
		
	},

	operador: {
		static: [
			"ticket-options:transferWhatsapp",
			"ticket-options:deleteTicket",
			"contacts-page:deleteContact",
			"drawer-admin-connections:view"
		

		],
	},

	admin: {
		static: [
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"ticket-options:transferWhatsapp",
			"contacts-page:deleteContact",
			"drawer-admin-connections:view"
		],
	},
};

export default rules;
